import { useContext } from "react";
import { InterfaceListPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(InterfaceListPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
